interface IGenderLibrary {
  value: string;
  text: string;
}

type GenderLibrary = Array<IGenderLibrary>;

const genderLibrary: GenderLibrary = [
  { value: 'M', text: 'Мужчина' },
  { value: 'W', text: 'Женщина' },
];

export { GenderLibrary };
export default genderLibrary;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/requestform/genderLibrary.ts